import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DatePipe, CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { PharmHeader } from '../pharm-header/pharm-header';
import { PharmSidebar } from '../pharm-sidebar/pharm-sidebar';

const baseUrl = 'https://logs.proofile.com.ng/api';

@Component({
  selector: 'app-transfer-log',
  standalone: true,
  imports: [CommonModule, FormsModule, DatePipe, PharmHeader, PharmSidebar],
  templateUrl: './transfer-log.html',
  styleUrl: './transfer-log.css'
})
export class TransferLog implements OnInit {
  transfers: any[] = [];
  loading = false;
  searchTerm = '';
  fromDate: string = '';
  toDate: string = '';
  currentPage = 1;
  pageSize = 10;
  storeId!: number;

  constructor(private http: HttpClient) {}

  ngOnInit() {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    this.storeId = user?.store_id;

    if (!this.storeId) {
      console.error('❌ No store ID found for user.');
      return;
    }

    this.fetchTransfers();
  }

  fetchTransfers() {
    this.loading = true;
    this.http.get<any[]>(`${baseUrl}/store-transfers/store/${this.storeId}`).subscribe({
      next: (data) => {
        this.transfers = data;
        this.loading = false;
      },
      error: () => {
        this.loading = false;
        console.error('❌ Failed to load transfer logs');
      }
    });
  }

  getFilteredTransfers(): any[] {
    return this.transfers.filter(t => {
      const text = `${t.stock_name} ${t.from_store} ${t.to_store}`.toLowerCase();
      const term = this.searchTerm.toLowerCase();
      const textMatch = text.includes(term);

      const date = new Date(t.transfer_date);
      const from = this.fromDate ? new Date(this.fromDate) : null;
      const to = this.toDate ? new Date(this.toDate) : null;

      const dateMatch =
        (!from || date >= from) &&
        (!to || date <= to);

      return textMatch && dateMatch;
    });
  }

  paginatedTransfers(): any[] {
    const filtered = this.getFilteredTransfers();
    const start = (this.currentPage - 1) * this.pageSize;
    return filtered.slice(start, start + this.pageSize);
  }
}
